import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AppProvider } from '@/context/AppContext';
import { initErrorCapture } from '@/services/error-capture';
import ToastStack from '@components/shared/ToastStack';
import ToastContainer from '@components/shared/ToastContainer';
import LogPanel from '@components/shared/LogPanel';
import FatalErrorModal from '@components/shared/FatalErrorModal';

// Hide LogPanel in production
const isProduction = import.meta.env.PROD;

/**
 * App Component - Uses modern React Context API
 * Wraps the application with AppProvider
 * Initializes error capture and renders notification components
 */
function App({ context, children }) {
    // Initialize error capture on mount
    useEffect(() => {
        initErrorCapture();
    }, []);
    
    // Only show LogPanel in admin section and not in production
    // Check isAdmin in useEffect to avoid hydration mismatches (window not available during SSR)
    const [isAdmin, setIsAdmin] = useState(false);
    
    useEffect(() => {
        setIsAdmin(typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'));
    }, []);
    
    return (
        <AppProvider value={context}>
            {children}
            <ToastStack />
            <ToastContainer />
            {isAdmin && !isProduction && <LogPanel />}
            <FatalErrorModal />
        </AppProvider>
    );
}

App.propTypes = {
    context: PropTypes.shape({
        setStatus: PropTypes.func.isRequired,
        urlBase: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        content: PropTypes.object,
        theme: PropTypes.object,
    }).isRequired,
    children: PropTypes.node.isRequired,
};

export default App;
